import WebApiService from "@/services/webapi.service.js";

const state = {
    ordini : null,
    Ordine: null,
    SpSpedizione: 0,
    ListSconti: [],
    OrdiniCount: [],
    ChkSeasonalOrders: false,
    keyword: null,
    OrderFilter: null
}

const getters =  {
    getOrderFilter: (state) => {
        let v = localStorage.getItem('OrderFilter');
        if(v != null && v != undefined){
            return state.OrderFilter ?? JSON.parse(v);
        }
        return null;
    },
    getOrdini: (state)=> {
        let v = localStorage.getItem("ordini");
        if(v != null && v != "undefined"){
            return state.ordini ??  JSON.parse(v);
        }
        return [];
    },
    getOrdine: (state) => {
        let v = localStorage.getItem("Ordine");
        if(v != null && v != "undefined"){
            return state.Ordine ??  JSON.parse(v);
        }
        return null;
    },
    getSpSpedizione: (state) => {
        return state.SpSpedizione;
    },
    getScontoSelected: (state) => (id) =>{
        return (state.ListSconti[id] ?? 0);
    },
    getOrdiniCount: (state) => (type )=>{
        let v = localStorage.getItem("OrdiniCount");
        let ordini = null;
        if(v != null && v[type] != null){
            ordini = JSON.parse(v[type]);
        }
        return state.OrdiniCount[type] ?? ordini;
    },
    getChkSeasonalOrders: (state) => {
        return state.ChkSeasonalOrders;
    },
    getKeyword: (state) => {
        return state.keyword;
    }
}

const mutations = {
    setOrderFilter: (state, orderFilter) =>{
        state.OrderFilter = orderFilter;
        localStorage.setItem('OrderFilter',JSON.stringify(state.OrderFilter));
    },
    setOrdini: (state, ordini) => {
        state.ordini = ordini;
        localStorage.setItem('ordini',JSON.stringify(state.ordini));
    },
    setOrdine:(state, ordine) => {
        state.Ordine = ordine;
        localStorage.setItem('Ordine',JSON.stringify(state.Ordine));
    },
    setSpSpedizione: (state, data) => {
        state.SpSpedizione = data;
    },
    setScontoSelected:(state, data) => {
        state.ListSconti[data.CodiceCatalogo] = data;
    },
    setOrdiniCount: (state, count) =>{
        state.OrdiniCount[count.type] = count.total;
        localStorage.setItem('OrdiniCount',JSON.stringify(state.OrdiniCount));
    },
    setChkSeasonalOrders: (state, data) =>{
        state.ChkSeasonalOrders = data;
    },
    setKeyword: (state, data) => {
        state.keyword = data;
    }
}

const actions = {
    GetOrdiniApi: ({commit}, data) => {
        let ordType =  data.state;
        return WebApiService.get("Ordini/",data.Token, {
            startIndex: data.pagina, 
            offset: data.offset, 
            state : data.state, 
            idOrder: data.idOrdine, 
            filter: data.filter,
            from: data.from,
            to: data.to,
            dtFrom: data.dtFrom,
            dtTo: data.dtTo
        }).then(
            (data) =>{
                if(data){
                    var ordini = data.data?.Orders;
                    commit("setOrdini",ordini);
                    commit("setOrdiniCount",{type: ordType, total:data.data?.TotalOrders});
                    commit("setChkSeasonalOrders", data.data?.ChkSeasonalOrder);
                }
            }
        );
    }
}

export default {
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}